import React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { partial } from 'lodash';
import StatusDropdown from 'src/common/status-dropdown.component.js';
import ClientRequestStatusDropdown from 'src/common/client-request-status-dropdown.component'
import Disposable from 'react-disposable-decorator';
import { getTask, patchTask } from 'src/resources/tasks.resource.js';
import { successToast } from 'toast-service!sofe';
import {UserTenantProps} from 'cp-client-auth!sofe'
import { catchAsyncStacktrace } from 'auto-trace';
import { Dialog } from 'primary-navbar!sofe';
import statusStyles from 'src/common/status-dropdown.styles.css';
import { getTaskStr } from 'src/common/get-task-str';

// This component, and what it uses, are being exported
// and are shared to other projects
@UserTenantProps({permissions: {userCanEditStatus: 'tasks_status'}})
@Disposable
export default class StatusCell extends React.Component {
  constructor() {
    super();
    this.state = {
      dropdownOpen: false,
    };
  }

  static defaultProps = {
    disabled: false,
  }

  render() {
    const selectedStatus = this.props.statuses.find(
      status => status.id === this.props.statusId
    );

    const {userCanEditStatus} = this.props.permissions || {}

    const isClientRequest = this.props.task.request_tools && this.props.task.request_tools.length > 0 && this.props.task.request_tools[0].tool_type === 'simple'
    const taskStr = getTaskStr('task', this.props.loggedInUser)

    if (selectedStatus && (this.props.task.type === 'Client Request' || isClientRequest)){
      return <div>
        <ClientRequestStatusDropdown
          selectedStatus={selectedStatus.id}
          onSelect={this.updateClientRequestStatus}
          width={this.props.width}
          disabled={this.props.disabled || !userCanEditStatus}
        />
    </div>
    }
    return (
      <div style={{maxWidth: '100%'}}>
        <div
          className={`${this.props.disabled || !userCanEditStatus ? '' : css(styles.clickTarget)} ${css(styles.statusRow)}`}
          onClick={partial(this.toggleDropdown, true)}
          onMouseDown={e => e.stopPropagation()}>
          <span>
            <div
              style={{ background: this.props.statusColor }}
              className={`${css(styles.statusDot)} ${this.props.statusName == "No status" ? statusStyles.noStatusBorder : ''}`}
              title={this.props.statusName}
            />
          </span>
          <div className="cps-ellipsis">{this.props.statusName}</div>
        </div>
        {this.state.dropdownOpen && <StatusDropdown
          width={'250px'}
          userId={this.props.loggedInUser.id}
          statuses={this.props.statuses}
          close={partial(this.toggleDropdown, false)}
          updateTaskStatus={this.updateStatus}
          updateStatuses={this.props.updateStatuses}
          selectedStatus={selectedStatus}
        />}
        {this.state.showCompleteSubtasksModal &&
          <Dialog>
            <div className="cps-modal">
              <div className="cps-modal__screen" />
              <div className="cps-modal__dialog cps-card__height-3" style={{ top: '10%' }}>
                <div className="cps-card__header cps-subheader-sm">
                  <span>Would you like to update subtasks?</span>
                  <a
                    onClick={this.closeCompleteSubtasksModal}
                    className="cps-modal__dialog__close cps-icon cps-icon-close"
                  />
                </div>
                <div className={`cps-card__body`}>
                  {`This ${taskStr} contains subtasks that are not complete. Would you like to update all subtasks as well?`}
                </div>
                <div className="cps-modal__dialog__actions">
                  <button onClick={this.markAllSubtasksCompleted} className="cps-btn +primary">
                    Yes
                  </button>
                  <a onClick={this.closeCompleteSubtasksModal} className="cps-link">
                    No
                  </a>
                </div>
              </div>
            </div>
          </Dialog>
        }
      </div>
    );
  }

  closeCompleteSubtasksModal = () => {
    const completedStatus = this.props.statuses.find(s => s.id === 'COMPLETED');
    this.props.updateTaskAttributes({taskIds: [this.props.task.id], newValues: {
      status_color: completedStatus.color,
      status_name: completedStatus.name,
      status_id: 'COMPLETED',
    }});
    this.setState({
      showCompleteSubtasksModal: false,
    });
  }
  markAllSubtasksCompleted = () => {
    const {task} = this.props;
    this.closeCompleteSubtasksModal();
    getTask(task.parent_task_id ? task.parent_task_id : task.id).subscribe(
      task => {
        const completedStatus = this.props.statuses.find(s => s.id === 'COMPLETED');
        const ids = task.subtasks.map(s => s.id);
        patchTask(ids.join(','), {
          status_color: completedStatus.color,
          status_name: completedStatus.name,
          status_id: 'COMPLETED',
        }).subscribe(
          () => {
            this.props.updateTaskAttributes({taskIds: [this.props.task.id], newValues: {
              subtask_completed_sum: this.props.task.subtask_total,
            }});
            successToast('All subtasks marked as completed.')
          },
          catchAsyncStacktrace()
        );
      },
      catchAsyncStacktrace()
    );
  }
  updateStatus = statusId => {
    // Update in memory
    const newStatus = this.props.statuses.find(
      status => status.id === statusId
    );

    if (
      statusId === 'COMPLETED' &&
      this.props.task.subtask_total > 0 &&
      this.props.task.subtask_completed_sum < this.props.task.subtask_total
    ) {
      this.setState({
        showCompleteSubtasksModal: true,
      });
    }
    else {
      this.props.updateTaskAttributes({taskIds: [this.props.task.id], newValues: {
        status_color: newStatus.color,
        status_name: newStatus.name,
        status_id: statusId,
      }});
    }

  };
  toggleDropdown = (dropdownOpen, e) => {
    if (this.props.disabled || !this.props.permissions?.userCanEditStatus) {
      return
    }

    if (!dropdownOpen && this.props.unhoverRow) {
      this.props.unhoverRow();
    }
    this.setState({
      dropdownOpen,
    });
  };
  updateClientRequestStatus = (newStatus) => {

    this.props.updateTaskAttributes({taskIds: [this.props.task.id], newValues: {
      status_color: newStatus.color,
      status_name: newStatus.label,
      status_id: newStatus.value,
    }, isClientRequest: true});
  }
}

const styles = StyleSheet.create({
  clickTarget: {
    cursor: 'pointer',
    ':hover': {
      textDecoration: 'underline',
    },
  },
  statusDot: {
    marginRight: '16px',
    marginTop: '2px',
    width: '12px',
    height: '12px',
    borderRadius: '6px',
    float: 'left',
  },
  statusRow: {
    display: 'flex',
    alignItems: 'center',
  }
});
